<template>
  <el-dialog v-if="dataList" :title="title" @closed="_closed" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="top5" top="5vh" width="80%">
    <l-table :option="tableOption" :data="dataList">
      <template slot="importState" slot-scope="scope">
        <span v-if="scope.row.importState == -1" class="text-grey">{{ scope.row.importDesc }}</span>
        <span v-else-if="scope.row.importState == 0" class="text-blue">等待导入</span>
        <span v-else-if="scope.row.importState == 9" class="text-red">{{ scope.row.importDesc }}</span>
        <span v-else-if="scope.row.importState == 10" class="text-green">导入成功</span>
      </template>
    </l-table>
    <div slot="footer" class="dialog-footer">
      <div class="fl" v-if="stateInfo">
        <span class="margin-right">导入进度: {{ stateInfo.finish }}/{{ stateInfo.total }}</span>
        成功：<span class="text-green padding-lr-sm">{{ stateInfo.success }}</span> 失败：<span class="text-red padding-lr-sm">{{ stateInfo.fail }}</span> 忽略<span class="text-grey padding-lr-sm">{{
          stateInfo.ignore
        }}</span>
      </div>
      <el-button @click="_cancle">取 消</el-button>
      <el-button type="primary" @click="doImport">开始导入</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: '', // 内置参数,误删
      visible: true, // 内置参数,误删
      dataList: null,
      stateInfo: null,
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index' },
          { label: '姓名', prop: 'name', overflow: true },
          { label: '手机号', prop: 'mobile' },
          { label: '部门', prop: 'departName', overflow: true },
          { label: '性别', prop: 'gender', overflow: true },
          { label: '身份证号', prop: 'identityNo', overflow: true },
          { label: '工号', prop: 'job_number', overflow: true },
          { label: '导入状态', slot: 'importState' }
        ]
      }
    }
  },
  methods: {
    _closed() {
      // 底层内置方法 误删
      this.onclosed()
    },
    _cancle() {
      // 底层内置方法 误删
      this.visible = false
      this.cancle && this.cancle()
    },
    doImport() {
      this.$lgh.msgConfirm('确认开始导入明细?', () => {
        this.stateInfo = {
          total: this.dataList.length,
          finish: 0,
          ignore: 0,
          fail: 0,
          success: 0
        }
        this.importItem(0, this.dataList[0])
      })
    },
    importItem(index, data) {
      var isLast = false
      if (index === this.stateInfo.total - 1) isLast = true
      this.$lgh.post('api/enterprise/employee/import/item?isLast=' + isLast, Object.assign({}, data)).then(res => {
        data.importState = res.importState
        data.importDesc = res.importDesc
        this.stateInfo.finish++
        if (res.importState === -1) this.stateInfo.ignore++
        else if (res.importState === 9) this.stateInfo.fail++
        else if (res.importState === 10) this.stateInfo.success++
        if (isLast) {
          this.$lgh.msgConfirm('导入完成，关闭导入窗口?', () => {
            this.visible = false
            this.onsuccess && this.onsuccess(this.dataList)
          })
        } else {
          this.importItem(index + 1, this.dataList[index + 1])
        }
      })
    }
  }
}
</script>

<style></style>
